import { useScopedAppFlagStore } from '@frontend/scope';

export const useScheduleSmallMode = () => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const isSmallModeEnabled = getFeatureFlagValue('schedule-small-mode', 'ALL');

  return { isSmallModeEnabled };
};
